/**
 * Wireless-only Shopify checkout selector for the Sel-2 product hero.
 * Same UI as the Shopify checkout selector without Choose Model — style is
 * locked to Wireless and matched against the existing product variant matrix.
 */
(function () {
  'use strict';

  if (typeof window !== 'undefined' && typeof window.is1 !== 'function') {
    window.is1 = function (value) {
      return value === 1 || value === '1';
    };
  }

  function parseJson(element) {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('[sel-2] Invalid shopify checkout selector JSON', error);
      return null;
    }
  }

  function formatMoney(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        var format =
          (window.theme && window.theme.moneyFormat) ||
          window.Shopify.money_format ||
          '${{amount}}';
        return window.Shopify.formatMoney(value, format);
      } catch (error) {
        // Use the USD fallback below.
      }
    }

    return '$' + (value / 100).toFixed(2);
  }

  function getOptionValue(variant, position) {
    if (!variant || !position) return '';
    return String(variant['option' + position] || '').trim();
  }

  function toHandlePart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildVariantHandle(variant) {
    if (!variant) return '';
    if (variant.image_filter_handle) return String(variant.image_filter_handle);

    return ['option1', 'option2', 'option3']
      .map(function (key) {
        return toHandlePart(variant[key]);
      })
      .filter(Boolean)
      .join('-');
  }

  function normalizeModel(value) {
    var model = String(value || '').toLowerCase();
    if (
      model.indexOf('wireless') !== -1 &&
      model.indexOf('non') === -1 &&
      model.indexOf('plug') === -1
    ) {
      return 'wireless';
    }
    if (
      model.indexOf('plug') !== -1 ||
      model.indexOf('non-wireless') !== -1 ||
      model.indexOf('non wireless') !== -1
    ) {
      return 'non-wireless';
    }
    return '';
  }

  function normalizeSize(value) {
    var size = String(value || '').toLowerCase();
    if (size.indexOf('7') !== -1) return '7l';
    if (size.indexOf('4') !== -1) return '4l';
    return '';
  }

  function optionValuesMatch(left, right, kind) {
    var a = String(left || '').trim();
    var b = String(right || '').trim();
    if (!a || !b) return false;
    if (a === b) return true;
    if (kind === 'size') {
      var sizeA = normalizeSize(a);
      var sizeB = normalizeSize(b);
      return Boolean(sizeA && sizeB && sizeA === sizeB);
    }
    if (kind === 'style') {
      var modelA = normalizeModel(a);
      var modelB = normalizeModel(b);
      return Boolean(modelA && modelB && modelA === modelB);
    }
    return a.toLowerCase() === b.toLowerCase();
  }

  function uniqueOptionValues(variants, position) {
    var values = [];
    if (!variants || !position) return values;
    for (var i = 0; i < variants.length; i += 1) {
      var value = getOptionValue(variants[i], position);
      if (value && values.indexOf(value) === -1) values.push(value);
    }
    return values;
  }

  function scoreStyleValues(values) {
    var score = 0;
    for (var i = 0; i < values.length; i += 1) {
      if (normalizeModel(values[i])) score += 3;
      if (/wireless|plug/i.test(values[i])) score += 1;
    }
    return score;
  }

  function scoreSizeValues(values) {
    var score = 0;
    for (var i = 0; i < values.length; i += 1) {
      if (normalizeSize(values[i])) score += 3;
      if (/capacity|liter|gal/i.test(values[i])) score += 1;
    }
    return score;
  }

  function scoreBundleValues(values) {
    var score = 0;
    for (var i = 0; i < values.length; i += 1) {
      if (/gift|dental|bundle/i.test(values[i])) score += 3;
      if (/with|without/i.test(values[i])) score += 1;
    }
    return score;
  }

  function detectOptionPositions(variants, fallback) {
    fallback = fallback || {};
    var candidates = [1, 2, 3].map(function (pos) {
      var values = uniqueOptionValues(variants, pos);
      return {
        pos: pos,
        style: scoreStyleValues(values),
        size: scoreSizeValues(values),
        bundle: scoreBundleValues(values)
      };
    });

    function pick(role, fallbackPos) {
      var ranked = candidates.slice().sort(function (a, b) {
        return b[role] - a[role];
      });
      for (var i = 0; i < ranked.length; i += 1) {
        if (ranked[i][role] > 0 && !pick.used[ranked[i].pos]) {
          pick.used[ranked[i].pos] = true;
          return ranked[i].pos;
        }
      }
      return Number(fallbackPos) || 0;
    }
    pick.used = {};

    return {
      style: pick('style', fallback.style || 1),
      size: pick('size', fallback.size || 2),
      bundle: pick('bundle', fallback.bundle || 3)
    };
  }

  function isPreferredGiftVariant(variant, bundlePosition) {
    if (!variant || !bundlePosition) return false;
    var value = getOptionValue(variant, bundlePosition).toLowerCase();
    return (
      value.indexOf('with') !== -1 &&
      (value.indexOf('gift') !== -1 || value.indexOf('dental') !== -1)
    );
  }

  function getSellingPlanIdFromVariant(variant) {
    if (!variant || variant.selling_plan_id == null || variant.selling_plan_id === '') {
      return null;
    }
    var planId = parseInt(variant.selling_plan_id, 10);
    return window.is1(planId) ? null : planId;
  }

  function buildCartItemsFromVariant(variant) {
    var items = [];
    if (!variant || !variant.id) return items;

    var mainItem = {
      id: parseInt(variant.id, 10),
      quantity: 1
    };

    // Always attach selling plan when the matched variant has one.
    var sellingPlanId = getSellingPlanIdFromVariant(variant);
    if (sellingPlanId) mainItem.selling_plan = sellingPlanId;

    items.push(mainItem);
    return items;
  }

  function addItemsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res
          .json()
          .then(function (err) {
            throw new Error(err.description || 'Failed to add to cart');
          })
          .catch(function () {
            throw new Error('Failed to add to cart');
          });
      }
      return res.json();
    });
  }

  function showCartAfterAdd() {
    if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
      return;
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      fetch('/?section_id=cart-drawer')
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh && cartDrawer.parentNode) {
            cartDrawer.parentNode.replaceChild(fresh, cartDrawer);
            cartDrawer = document.querySelector('cart-drawer');
          }
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        })
        .catch(function () {
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        });
      return;
    }

    document.dispatchEvent(new Event('cart:refresh'));
    document.dispatchEvent(new Event('cart:open'));
  }

  function resolveWirelessStyle(variants, stylePosition, preferred) {
    var preferredValue = String(preferred || '').trim();
    if (preferredValue) {
      var preferredLower = preferredValue.toLowerCase();
      if (
        preferredLower.indexOf('wireless') !== -1 &&
        preferredLower.indexOf('plug') === -1
      ) {
        return preferredValue;
      }
    }

    for (var i = 0; i < variants.length; i += 1) {
      var value = getOptionValue(variants[i], stylePosition);
      var lower = value.toLowerCase();
      if (lower.indexOf('wireless') !== -1 && lower.indexOf('plug') === -1) {
        return value;
      }
    }

    return preferredValue || 'Wireless';
  }

  function initializeSelector(wrapper) {
    if (!wrapper || wrapper.hasAttribute('data-sel-2-scw-bound')) return;

    var selector = wrapper.querySelector(
      '[data-sel-2-shopify-ck-wireless]'
    );
    var variantsData = parseJson(
      wrapper.querySelector('#sel-2-product-variants-data')
    );
    var checkoutConfig = parseJson(
      wrapper.querySelector('[data-sel-2-shopify-ck-wireless-config]')
    );

    if (
      !selector ||
      !variantsData ||
      !Array.isArray(variantsData.variants) ||
      !variantsData.variants.length
    ) {
      return;
    }

    wrapper.setAttribute('data-sel-2-scw-bound', 'true');

    var variants = variantsData.variants;
    var detectedPositions = detectOptionPositions(variants, {
      style:
        (checkoutConfig && checkoutConfig.stylePosition) ||
        variantsData.style_position ||
        1,
      size:
        (checkoutConfig && checkoutConfig.sizePosition) ||
        variantsData.size_position ||
        2,
      bundle:
        (checkoutConfig && checkoutConfig.bundlePosition) ||
        variantsData.bundle_position ||
        3
    });
    var stylePosition = detectedPositions.style || 1;
    var sizePosition = detectedPositions.size || 2;
    var bundlePosition = detectedPositions.bundle || 3;
    var lockedStyle =
      (checkoutConfig && checkoutConfig.lockedStyle) ||
      selector.getAttribute('data-selected-style') ||
      '';
    var selectedStyle = resolveWirelessStyle(
      variants,
      stylePosition,
      lockedStyle
    );
    var selectedSize = selector.getAttribute('data-selected-size') || '';

    // Boot from the first available Wireless variant (catalog order).
    var initialWireless = null;
    for (var wi = 0; wi < variants.length; wi += 1) {
      if (normalizeModel(getOptionValue(variants[wi], stylePosition)) !== 'wireless') {
        continue;
      }
      if (!initialWireless) initialWireless = variants[wi];
      if (variants[wi].available !== false) {
        initialWireless = variants[wi];
        break;
      }
    }
    if (initialWireless) {
      selectedStyle =
        getOptionValue(initialWireless, stylePosition) || selectedStyle;
      selectedSize =
        getOptionValue(initialWireless, sizePosition) || selectedSize;
    }

    function getSelectedValue(attribute) {
      var active = selector.querySelector('[' + attribute + '].is-active');
      return active ? active.getAttribute('data-option-value') || '' : '';
    }

    function syncStateFromDom() {
      // Model is locked to Wireless — only size comes from the UI.
      selectedStyle = resolveWirelessStyle(
        variants,
        stylePosition,
        lockedStyle || selectedStyle
      );
      selectedSize = getSelectedValue('data-sel-2-sc-size') || selectedSize;
    }

    function matchingVariants(style, size) {
      return variants.filter(function (variant) {
        return (
          optionValuesMatch(
            getOptionValue(variant, stylePosition),
            style,
            'style'
          ) &&
          optionValuesMatch(
            getOptionValue(variant, sizePosition),
            size,
            'size'
          )
        );
      });
    }

    function isVariantAvailable(variant) {
      return Boolean(variant) && variant.available !== false;
    }

    function findVariant(style, size) {
      var matches = matchingVariants(style, size);
      if (!matches.length) return null;

      var availableMatches = matches.filter(isVariantAvailable);
      var pool = availableMatches.length ? availableMatches : matches;

      // Prefer gift/dental bundle within the available pool, else first available.
      for (var index = 0; index < pool.length; index += 1) {
        if (isPreferredGiftVariant(pool[index], bundlePosition)) {
          return pool[index];
        }
      }

      return pool[0];
    }

    function selectedVariant() {
      return findVariant(selectedStyle, selectedSize);
    }

    function ensureActiveSize() {
      var sizeButtons = selector.querySelectorAll('[data-sel-2-sc-size]');
      if (!sizeButtons.length) return;

      var matched = null;
      Array.prototype.forEach.call(sizeButtons, function (button) {
        if (matched) return;
        var value = button.getAttribute('data-option-value') || '';
        if (optionValuesMatch(value, selectedSize, 'size')) matched = button;
      });
      if (!matched) {
        matched = selector.querySelector('[data-sel-2-sc-size].is-active');
      }
      if (!matched) matched = sizeButtons[0];

      Array.prototype.forEach.call(sizeButtons, function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
      matched.classList.add('is-active');
      matched.setAttribute('aria-pressed', 'true');
      selectedSize = matched.getAttribute('data-option-value') || selectedSize;
    }

    function setText(selectorString, text) {
      var element = selector.querySelector(selectorString);
      if (element) element.textContent = text || '';
    }

    function setOptionalText(selectorString, text) {
      var element = selector.querySelector(selectorString);
      if (!element) return;
      element.textContent = text || '';
      element.hidden = !text;
    }

    function updateFountainImage() {
      var image = selector.querySelector('[data-sel-2-sc-fountain-image]');
      if (!image) return;

      var images =
        checkoutConfig && checkoutConfig.fountainImages
          ? checkoutConfig.fountainImages
          : null;
      var nextSrc = images && images.wireless ? images.wireless : '';
      if (!nextSrc) return;

      image.src = nextSrc;
      image.removeAttribute('srcset');
      image.alt = '';
    }

    function updateIncludedAndSummary(variant) {
      if (!variant) return;

      var model =
        normalizeModel(selectedStyle) === 'wireless' ? 'Wireless' : 'Non-Wireless';
      var capacity = normalizeSize(selectedSize) === '7l' ? '7L' : '4L';
      var price = Number(variant.price) || 0;
      var compare = Number(variant.compare_at_price) || 0;
      var giftsValue = 5996;
      var totalCompare = Math.max(compare || price, price) + giftsValue;
      var savings = Math.max(totalCompare - price, 0);

      setText(
        '[data-sel-2-sc-fountain-title]',
        capacity + ' ' + model + ' Fountain'
      );
      setText('[data-sel-2-sc-fountain-price]', formatMoney(price));
      setOptionalText(
        '[data-sel-2-sc-fountain-compare]',
        compare > price ? formatMoney(compare) : ''
      );
      setText('[data-sel-2-sc-total-price]', formatMoney(price));
      setText('[data-sel-2-sc-total-compare]', formatMoney(totalCompare));
      setOptionalText(
        '[data-sel-2-sc-save]',
        savings > 0 ? 'SAVE ' + formatMoney(savings) : ''
      );
      updateFountainImage();
    }

    function updateHeroPriceAndCta(variant) {
      if (!variant) return;

      var currentPrice = formatMoney(variant.price);
      var comparePrice =
        Number(variant.compare_at_price) > Number(variant.price)
          ? formatMoney(variant.compare_at_price)
          : '';

      var currentElements = wrapper.querySelectorAll('[data-sel-2-price-current]');
      var compareElements = wrapper.querySelectorAll('[data-sel-2-price-compare]');

      Array.prototype.forEach.call(currentElements, function (element) {
        element.textContent = currentPrice;
        element.setAttribute('data-sel-2-price-cents', String(variant.price));
      });

      Array.prototype.forEach.call(compareElements, function (element) {
        element.textContent = comparePrice;
        element.hidden = !comparePrice;
        if (comparePrice) element.removeAttribute('hidden');
      });

      var button = wrapper.querySelector('[data-sel-2-atc-btn]');
      if (button) {
        var buttonPrice = button.querySelector('[data-sel-2-atc-price]');
        if (buttonPrice) {
          buttonPrice.textContent = currentPrice;
          buttonPrice.setAttribute('data-sel-2-price-cents', String(variant.price));
        }
      }
    }

    function notifyGallery(variant) {
      if (!variant) return;

      document.dispatchEvent(
        new CustomEvent('sel-2:variant-change', {
          detail: {
            force: true,
            model: selectedStyle,
            size: selectedSize,
            bundle: getOptionValue(variant, bundlePosition),
            variant_handle: buildVariantHandle(variant)
          }
        })
      );
    }

    function updateSelection(options) {
      options = options || {};
      syncStateFromDom();
      var variant = selectedVariant();
      updateIncludedAndSummary(variant);
      updateHeroPriceAndCta(variant);
      if (options.notifyGallery) notifyGallery(variant);
    }

    function selectSizeOption(option) {
      if (!option || !selector.contains(option)) return;
      var sizeButtons = selector.querySelectorAll('[data-sel-2-sc-size]');
      Array.prototype.forEach.call(sizeButtons, function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('is-active');
      option.setAttribute('aria-pressed', 'true');
      selectedSize = option.getAttribute('data-option-value') || selectedSize;
      selectedStyle = resolveWirelessStyle(
        variants,
        stylePosition,
        lockedStyle || selectedStyle
      );
      updateSelection({ notifyGallery: true });
    }

    // Capture on wrapper so size clicks work even with nested richtext markup.
    wrapper.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (target && target.nodeType === 3) target = target.parentElement;
        if (!target || typeof target.closest !== 'function') return;
        if (!selector.contains(target)) return;

        var sizeOption = target.closest('[data-sel-2-sc-size]');
        var guideTrigger = target.closest('.sel-2-sc-selector__guide-trigger');

        if (sizeOption) {
          event.preventDefault();
          selectSizeOption(sizeOption);
          return;
        }

        if (guideTrigger) {
          var guide = guideTrigger.parentElement.querySelector(
            '.sel-2-sc-selector__guide'
          );
          if (!guide) return;
          var willOpen = guide.hidden;

          var guides = selector.querySelectorAll('.sel-2-sc-selector__guide');
          var triggers = selector.querySelectorAll(
            '.sel-2-sc-selector__guide-trigger'
          );
          Array.prototype.forEach.call(guides, function (item) {
            item.hidden = true;
          });
          Array.prototype.forEach.call(triggers, function (item) {
            item.setAttribute('aria-expanded', 'false');
          });

          guide.hidden = !willOpen;
          guideTrigger.setAttribute(
            'aria-expanded',
            willOpen ? 'true' : 'false'
          );
        }
      },
      true
    );

    document.addEventListener('click', function (event) {
      if (selector.contains(event.target)) return;
      var guides = selector.querySelectorAll('.sel-2-sc-selector__guide');
      var triggers = selector.querySelectorAll(
        '.sel-2-sc-selector__guide-trigger'
      );
      Array.prototype.forEach.call(guides, function (guide) {
        guide.hidden = true;
      });
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    var cta = wrapper.querySelector('[data-sel-2-atc-btn]');
    if (cta && !cta.hasAttribute('data-sel-2-scw-atc-bound')) {
      cta.setAttribute('data-sel-2-scw-atc-bound', 'true');
      cta.removeAttribute('data-cta');
      cta.removeAttribute('data-sel-2-cc-claim');

      var isProcessing = false;

      function resetAddToCartButton() {
        isProcessing = false;
        var btn = wrapper.querySelector('[data-sel-2-atc-btn]');
        var loading = wrapper.querySelector('[data-sel-2-atc-loading]');
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.style.pointerEvents = '';
        }
        if (loading) {
          loading.classList.remove('is-active');
          loading.setAttribute('aria-hidden', 'true');
        }
      }

      cta.addEventListener(
        'click',
        function (event) {
          if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
          }
          if (event && typeof event.stopPropagation === 'function') {
            event.stopPropagation();
          }
          if (isProcessing) return;

          isProcessing = true;
          var btn = wrapper.querySelector('[data-sel-2-atc-btn]');
          var loading = wrapper.querySelector('[data-sel-2-atc-loading]');
          if (btn) {
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
            btn.style.pointerEvents = 'none';
          }
          if (loading) {
            loading.classList.add('is-active');
            loading.setAttribute('aria-hidden', 'false');
          }

          syncStateFromDom();
          var variant = selectedVariant();
          var items = buildCartItemsFromVariant(variant);

          if (!items.length) {
            alert('Please select all options before adding to cart.');
            resetAddToCartButton();
            return;
          }

          addItemsToCart(items)
            .then(function () {
              showCartAfterAdd();
            })
            .catch(function (err) {
              console.error('[sel-2] Add to cart failed', err);
              alert(
                'Failed to add item to cart: ' + (err.message || 'Please try again.')
              );
            })
            .finally(function () {
              resetAddToCartButton();
            });
        },
        true
      );
    }

    function initializeCountdown() {
      if (selector.hasAttribute('data-sel-2-sc-countdown-bound')) return;
      selector.setAttribute('data-sel-2-sc-countdown-bound', 'true');

      var storageKey = 'sel2ShopifyCheckoutWirelessTimerEndAt';
      var duration = 12 * 60 * 60 * 1000;
      var endAt = 0;

      try {
        endAt = Number(localStorage.getItem(storageKey)) || 0;
      } catch (error) {
        endAt = 0;
      }

      if (endAt <= Date.now()) {
        endAt = Date.now() + duration;
        try {
          localStorage.setItem(storageKey, String(endAt));
        } catch (error) {
          // The countdown still works for this page view.
        }
      }

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function tick() {
        var remaining = endAt - Date.now();
        if (remaining <= 0) {
          endAt = Date.now() + duration;
          remaining = duration;
          try {
            localStorage.setItem(storageKey, String(endAt));
          } catch (error) {
            // Ignore local storage failures.
          }
        }

        var totalSeconds = Math.floor(remaining / 1000);
        setText('[data-sel-2-sc-day]', pad(Math.floor(totalSeconds / 86400)));
        setText(
          '[data-sel-2-sc-hour]',
          pad(Math.floor((totalSeconds % 86400) / 3600))
        );
        setText(
          '[data-sel-2-sc-minute]',
          pad(Math.floor((totalSeconds % 3600) / 60))
        );
        setText('[data-sel-2-sc-second]', pad(totalSeconds % 60));
      }

      tick();
      window.setInterval(tick, 1000);
    }

    initializeCountdown();
    ensureActiveSize();
    updateSelection({ notifyGallery: true });
  }

  function initializeSocialProof() {
    var elements = document.querySelectorAll('[data-sel-2-social-count]');
    if (!elements.length) return;

    var storageKey = 'sel2DogParentsCounterV2';
    var state;
    try {
      state = JSON.parse(localStorage.getItem(storageKey) || 'null');
    } catch (error) {
      state = null;
    }

    var now = Date.now();
    if (!state || !state.startedAt || now - state.startedAt >= 86400000) {
      state = {
        count: Math.floor(Math.random() * 201) + 400,
        startedAt: now,
        updatedAt: now
      };
    }

    var elapsedSteps = Math.floor((now - state.updatedAt) / 300000);
    if (elapsedSteps > 0) {
      state.count += elapsedSteps * 3;
      state.updatedAt += elapsedSteps * 300000;
    }

    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      // Rendering does not depend on local storage.
    }

    Array.prototype.forEach.call(elements, function (element) {
      element.textContent = String(state.count);
    });
  }

  function formatUsShipDate(daysAhead) {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    var parts = formatter.formatToParts(new Date());
    var year = 0;
    var month = 0;
    var day = 0;
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].type === 'year') year = Number(parts[i].value);
      if (parts[i].type === 'month') month = Number(parts[i].value);
      if (parts[i].type === 'day') day = Number(parts[i].value);
    }

    var ship = new Date(Date.UTC(year, month - 1, day + (daysAhead || 2)));
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      weekday: 'short',
      month: 'short',
      day: '2-digit'
    }).format(ship);
  }

  function countryCodeToFlag(code) {
    if (!code || typeof code !== 'string' || code.length !== 2) return '🇺🇸';
    var upper = code.toUpperCase();
    if (!/^[A-Z]{2}$/.test(upper)) return '🇺🇸';
    return String.fromCodePoint(
      127397 + upper.charCodeAt(0),
      127397 + upper.charCodeAt(1)
    );
  }

  function applyShippingFlags(countryCode) {
    var flags = document.querySelectorAll('[data-sel-2-ship-flag]');
    if (!flags.length) return;
    var emoji = countryCodeToFlag(countryCode);
    Array.prototype.forEach.call(flags, function (element) {
      element.textContent = emoji;
      element.setAttribute('aria-label', String(countryCode || 'US').toUpperCase());
    });
  }

  function resolveVisitorCountryCode() {
    var storageKey = 'sel2VisitorCountryCodeV1';

    try {
      var cached = sessionStorage.getItem(storageKey);
      if (cached && /^[A-Za-z]{2}$/.test(cached)) {
        return Promise.resolve(cached.toUpperCase());
      }
    } catch (error) {
      // Continue without cache.
    }

    return fetch('/browsing_context_suggestions.json', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('browsing context lookup failed');
        return response.json();
      })
      .then(function (data) {
        var detected = data && data.detected_values ? data.detected_values : null;
        var code =
          (detected && detected.country && detected.country.handle) ||
          (window.Shopify && Shopify.country) ||
          'US';
        code = String(code || 'US');
        if (!/^[A-Za-z]{2}$/.test(code)) code = 'US';
        code = code.toUpperCase();
        try {
          sessionStorage.setItem(storageKey, code);
        } catch (error) {
          // Ignore storage failures.
        }
        return code;
      })
      .catch(function () {
        try {
          if (
            window.Shopify &&
            typeof Shopify.country === 'string' &&
            Shopify.country.length === 2
          ) {
            return Shopify.country.toUpperCase();
          }
        } catch (error) {
          // Fall through.
        }
        return 'US';
      });
  }

  function initializeShippingBars() {
    var dates = document.querySelectorAll('[data-sel-2-ship-date]');
    if (dates.length) {
      var label = formatUsShipDate(2);
      Array.prototype.forEach.call(dates, function (element) {
        element.textContent = label;
      });
    }

    var flags = document.querySelectorAll('[data-sel-2-ship-flag]');
    if (flags.length) {
      resolveVisitorCountryCode().then(applyShippingFlags);
    }
  }

  function initialize() {
    var wrappers = document.querySelectorAll('[data-sel-2-product-selector]');
    Array.prototype.forEach.call(wrappers, initializeSelector);
    initializeSocialProof();
    initializeShippingBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
